@if (options(); as options) {
  <dojo-button
    [matMenuTriggerFor]="menu"
    #matMenuTriggerForMenu="matMenuTrigger"
    [fill]="'outline'"
    class="trigger-button block"
    [size]="'s'"
  >
    <span class="w-full truncate text-left">
      @if (state.selectedOption?.name; as name) {
        <dojo-localized-string [content]="name"></dojo-localized-string>
      }
    </span>
    <dojo-icon [icon]="matMenuTriggerForMenu.menuOpen ? 'chevron-up' : 'chevron-down'" [size]="16"></dojo-icon>
  </dojo-button>

  <mat-menu #menu="matMenu" class="custom-mat-menu wide-width">
    <ng-template matMenuContent>
      <dojo-filterable-items-list
        [itemSize]="36"
        [items]="options"
        [selected]="syllabusIdCtrl.value ? [syllabusIdCtrl.value.toString()] : []"
        [identityFn]="identityFn"
        [filterPropertyValueFn]="filterPropertyValueFn"
        listMode="list"
        (selectItem)="setSelected($event); matMenuTriggerForMenu.closeMenu()"
        [searchPlaceholder]="'Search a syllabus'"
        [emptyListLabel]="'No syllabus found'"
      >
        <div *dojoListItem="options; let option" class="option-item text-md">
          <div class="flex w-full items-center justify-between gap-1">
            <span class="grow">{{ option.program.short_name }} {{ option.name }}</span>
            <dojo-icon [icon]="'check'" class="option-item-icon shrink-0" />
          </div>
        </div>
      </dojo-filterable-items-list>
    </ng-template>
  </mat-menu>
}
